import { useState, useEffect } from 'react';

export default function ProgressBar() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handler = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(docHeight > 0 ? (scrollTop / docHeight) * 100 : 0);
    };
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full z-[60] pointer-events-none" style={{ height: '3px' }}>
      <div
        className="h-full transition-all duration-75 ease-linear"
        style={{
          width: `${progress}%`,
          background: 'linear-gradient(90deg, #0D47A1, #00897B)',
        }}
      />
    </div>
  );
}
